import { useTranslation, LOCALES, type Locale } from "../i18n";

export function LanguagePicker() {
  const { locale, setLocale, t } = useTranslation();

  return (
    <label className="relative flex items-center">
      <span className="sr-only">{t("nav.language")}</span>
      <select
        value={locale}
        onChange={(event) => setLocale(event.target.value as Locale)}
        aria-label={t("nav.language")}
        className="cursor-pointer appearance-none rounded-lg bg-transparent py-1.5 pl-2 pr-6 text-sm font-semibold text-ink-muted transition-colors hover:bg-surface-sunken hover:text-ink"
      >
        {LOCALES.map((option) => (
          <option key={option.code} value={option.code}>
            {option.code.toUpperCase()}
          </option>
        ))}
      </select>
      <span
        aria-hidden="true"
        className="pointer-events-none absolute right-2 text-[0.6rem] text-ink-faint"
      >
        ▼
      </span>
    </label>
  );
}
